import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Root"] */ "/app/src/components/Root.tsx");
